import { useSyncExternalStore } from "react";

// One shared 1-second ticker for the whole app: every countdown re-renders from the same
// clock instead of each row running its own interval.
let now = Date.now();
const listeners = new Set<() => void>();
let timer: ReturnType<typeof setInterval> | null = null;

function subscribe(fn: () => void) {
  listeners.add(fn);
  if (!timer) {
    timer = setInterval(() => {
      now = Date.now();
      listeners.forEach((l) => l());
    }, 1000);
  }
  return () => {
    listeners.delete(fn);
    if (!listeners.size && timer) {
      clearInterval(timer);
      timer = null;
    }
  };
}

/** Current time in ms, updated every second. */
export function useNow(): number {
  return useSyncExternalStore(subscribe, () => now, () => now);
}
